<template>
    <div class="each-camping">
        <div class="left-zone">
            <img :src="item.img" class="camping-img img-responsive" @error.once="__change__no__image">
            <!-- <img :src="hotIconSrc" class="hot-icon" alt="hot-icon"> -->
        </div>
        <div class="rignt-zone">
            <div class="title-text">
                <span class="text-wrapper">
                    <span v-text="item.name" class="title multiple-text-overflow"></span>
                </span>
            </div>
            <div v-if="item.salePrice || item.salePrice === 0" class="price-wrapper text-overflow">
                <span class="price">
                    <span class="dolar">￥</span>
                    <span class="number" v-text="item.salePrice"></span>
                </span>
            </div>
            <div class="tags"   v-if="item.tags.length>0 && item.tags[0] !=''">
                <div class="tag" v-for="(tag,i) of item.tags" :key="i" v-text="tag" v-show="tag!=''"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListOfCar",
    // inheritAttrs: false,
    props: {
        item: Object
    },
    data() {
        return {
            hotIconSrc: ""
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.hotIconSrc = API.ossUrl + "common/hot-icon.png";
    },
    destroyed() {},
    methods: {}
};
</script>


<style scoped lang="scss">
.each-camping {
    padding-bottom: 0.64rem;
    display: flex;
    justify-content: space-between;
    &:nth-last-child(2) {
        border-bottom: 0;
    }
    .left-zone {
        box-shadow: 0px 2px 4px rgba(140, 140, 140, 0.3);
        border-radius: 0.266667rem;
        margin-right: 0.32rem;
        width: 2.56rem;
        height: 2.56rem;
        position: relative;
        .camping-img {
            border-radius: 0.266667rem;
            width: 2.56rem;
            height: 2.56rem;
        }
        .hot-icon {
            width: 1.066667rem;
            height: 0.64rem;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    .rignt-zone {
        width: 6.1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title-text {
            display: flex;
            // align-items: center;
            justify-content: space-between;
            max-height: 1.173333rem;
            .text-wrapper {
                display: flex;
            }
            .title {
                font-weight: bold;
                color: #343434;
                font-size: 16px;
                vertical-align: middle;
                max-width: 6.213333rem;
                line-height: 0.586667rem;
                // min-height: 1.12rem;
            }
        }
        .tags {
            width: 6.053333rem;
            display: flex;
            flex-wrap: nowrap;
            padding-right: 2px;
            .tag {
                padding: 0.045rem 0.08rem;
                color: #4d4dae;
                // margin-bottom: 0.133333rem;
                margin-right: 0.133333rem;
                font-size: 12px;
                flex: 0 0 auto;
                line-height: 0.453333rem;
                border: 1px solid rgba(77, 77, 174, 1);
                border-radius: 0.16rem;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            // .tag {
            //     padding: 0.08rem;
            //     display: inline-block;
            //     line-height: 0.453333rem;
            //     color: #4d4dae;
            //     border-radius: 0.16rem;
            //     border: 1px solid rgba(77, 77, 174, 1);
            //     border-radius: 0.16rem;
            //     font-size: 0.32rem;
            //     font-weight: 400;
            //     text-align: center;
            //     margin-right: 0.266667rem;
            //     margin-bottom: 0.133333rem;
            // }
        }
        .tags::-webkit-scrollbar {
            display: none;
        }
        .price-wrapper {
            // margin-top: 0.026667rem;
            // margin-bottom: 0.026667rem;
            .price {
                font-size: 0.533333rem;
                color: #ff9200;
                flex: none;
                // line-height: 0.453333rem;
                .dolar {
                    font-weight: bold;
                }
                .number {
                    // font-size: 17px;
                    // color: $orange;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>

